<template>
  <div class="networkDevice">
    <el-container>
      <el-main style="margin:0px;padding:0px;">
          <el-row>
            <el-col :span="4">
              <el-row>
                <img width="170px" height="170px" src="@/assets/image/dtu.png">
              </el-row>
              <el-row>
                <a href="#">DTU数传终端</a>
              </el-row>
            </el-col>
            <el-col :span="5">
              <el-row>
              <img width="170px" height="170px" src="@/assets/image/router.png">
              </el-row>
              <el-row>
                <a href="#">工业路由器</a>
              </el-row>
            </el-col>
            <el-col :span="5">
              <el-row>
              <img width="170px" height="170px" src="@/assets/image/switch.png">
              </el-row>
              <el-row>
                <a href="#">工业交换机</a>
              </el-row>
            </el-col>
            <el-col :span="5">
              <el-row>
              <img width="170px" height="170px" src="@/assets/image/gateway.png">
              </el-row>
              <el-row>
                <a href="#">工业网关</a>
              </el-row>
            </el-col>
            <el-col :span="5">
              <el-row>
              <img width="170px" height="170px" src="@/assets/image/nbiot.png">
              </el-row>
              <el-row>
                <a href="#">NB-IOT终端</a>
              </el-row>
            </el-col>
          </el-row>
          <el-row style="margin-top:20px;">
            <el-col :span="4">
              <el-row>
                <img width="170px" height="170px" src="@/assets/image/smartwifi.png">
              </el-row>
              <el-row>
                <a href="#">智慧WiFi终端</a>
              </el-row>
            </el-col>
            <el-col :span="5">
              <el-row>
              <img width="170px" height="170px" src="@/assets/image/serial_com.png">
              </el-row>
              <el-row>
                <a href="#">工业串口转换器</a>
              </el-row>
            </el-col>
            <el-col :span="5">
              <el-row>
              <img width="170px" height="170px" src="@/assets/image/net_mgr_switch.png">
              </el-row>
              <el-row>
                <a href="#">网管交换机</a>
              </el-row>
            </el-col>
            <el-col :span="5">
              <el-row>
              <img width="170px" height="170px" src="@/assets/image/firework.png">
              </el-row>
              <el-row>
                <a href="#">工业防火墙</a>
              </el-row>
            </el-col>
            <el-col :span="5">
              <el-row>
              <img width="170px" height="170px" src="@/assets/image/plc_gateway.png">
              </el-row>
              <el-row>
                <a href="#">PLC工业网关</a>
              </el-row>
            </el-col>
          </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'networkDevicePage'
}
</script>

<style lang="less" scoped>
body {
  margin: 0px;
}
.el-main {
  margin: 10px;
  padding: 10px;
  height: 700px;
}
.el-row {
  margin-top: 0px;
  padding-top: 10px;
}
a:link {
  text-decoration:none;
  cursor:pointer;
  font-size: 16px;
  }
</style>
